import { createFileRoute, redirect } from "@tanstack/react-router";

export const Route = createFileRoute("/prototype/c/$companyId/")({
  beforeLoad: ({ params }) => {
    throw redirect({ to: "/prototype/c/$companyId/home", params });
  },
});
